<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-stroke-${color}`"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 10.5L8 11.5" />
    <path d="M8 4.5L8 9.83333" />
    <circle cx="8" cy="8" r="5.5" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
